export default __webpack_public_path__ + "static/media/group.16c19a5c.svg";